import { useState, useEffect } from 'react'

export const useThrottledValue = (input, delay = 250) => {
  const [value, setValue] = useState(input)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setValue(input)
    }, delay)

    return () => {
      clearTimeout(timeout)
    }
  }, [input, delay])

  return value
}
